export default __webpack_public_path__ + "public/assets/images/db94f88f6055e9319d474057919339de.png";